import PropTypes from 'prop-types';
import { Link as RouterLink  } from "react-router-dom";
// @mui
import { styled } from '@mui/material/styles';
import { Link, Box, Stack, AppBar, Toolbar, Button } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/iconify';
//
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';

import Logo from '../../../components/logo';

// ----------------------------------------------------------------------

const NAV_WIDTH = 280;

const HEADER_MOBILE = 64;

const HEADER_DESKTOP = 92;

const StyledRoot = styled(AppBar)(({ theme, position = 'fixed' }) => ({
  ...bgBlur({ color: "#E9EFF4" }), // theme.palette.background.default
  boxShadow: 'none',
  position,
  // [theme.breakpoints.up('lg')]: {
  //   width: `calc(100% - ${NAV_WIDTH + 1}px)`,
  // },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: HEADER_MOBILE,
  [theme.breakpoints.up('xl')]: {
    minHeight: HEADER_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

Header.propTypes = {
  onOpenNav: PropTypes.func,
};

export default function Header({ onOpenNav, isLoggedIn }) {

  return (
    <StyledRoot position={isLoggedIn ? 'fixed' : 'fixed'}>
      <StyledToolbar>
      <Logo path={isLoggedIn ? '/app' : '/'}/>
        {/* <IconButton
          onClick={onOpenNav}
          sx={{
            mr: 1,
            color: 'text.primary',
            display: { lg: 'none' },
          }}
        >
          <Iconify icon="eva:menu-2-fill" />
        </IconButton> */}

        {/* <Searchbar /> */}
        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{
            xs: 3,
            sm: 5,
          }}
        >
          {/* <LanguagePopover />
          <NotificationsPopover /> */}
          {isLoggedIn ?
            <AccountPopover />
            :
            <>
            <Link to="/pricing" component={RouterLink} underline="hover" color="#444943">Pricing</Link>
            <Button
              to="/login"
              variant="outlined"
              component={RouterLink}
              sx={{
                borderRadius: 35,
                paddingX: 3,
              }}
            >
                Login
            </Button>
            </>
          }
        </Stack>
      </StyledToolbar>
    </StyledRoot>
  );
}
